import { ReactElement, useEffect, useState } from 'react';
import { AppConfiguration } from '../lib/type';
import DataTable from './Table/DataTable';

export interface WorldMapTableProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
}

const WorldMapTable = ({ configuration }: WorldMapTableProps): ReactElement => {
  const [isArabic, setIsArabic] = useState(false);

  useEffect(() => {
    const checkArabic = () => {
      const url = window.location.href;
      const isArabicLocale =
        url.includes('/sa-ar') || url.includes('globals=locale:ar');
      setIsArabic(isArabicLocale);
    };

    checkArabic();
  }, []);

  return (
    <div>
      <div className="ibm-grid-container ibm-duo-u--relative widget-styles">
        <div
          className="ibm-grid-col-sm-4-4 ibm-grid-col-md-8-8 ibm-grid-col-lg-16-16 ibm-duo-u--relative"
          dir={isArabic ? 'rtl' : 'ltr'}
        >
          <DataTable
            description={configuration.description}
            groups={configuration.groups}
            legends={configuration.legends}
          />
        </div>
      </div>
    </div>
  );
};

export default WorldMapTable;
